<mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
<app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
<div class="panel-container" *ngIf="panel">
    <nav class="navbar navbar-expand-sm navbar-light bg-light justify-content-between section-header mb-2" *ngIf="!showflat">
        <div><span class="navbar-brand mb-0 h1"><i class="fas fa-dice-d6"></i> Panel Type:</span> <b>{{panel.model}}</b></div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <div class="navbar-nav ml-auto">
<!--                 <ul class="nav navbar-nav ml-auto">
                    <li class="nav-item mr-1" *ngIf="uiShowSaveBtn() ">
                        <button matTooltip="Save data" type="button" class="btn btn-sm  btn-success "
                            [disabled]="!myform.valid||submitted" (click)="saveModel()">
                            <i class="far fa-save"></i> Save
                        </button>
                    </li>
                </ul> -->
            </div>
        </div>
    </nav>
    <div>
        <table class="info-table">
            <tr>
                <th>Brand</th>
                <td>{{panel.brand}} </td>
            </tr>
            <tr>
                <th>Model</th>
                <td>{{panel.model}} </td>
            </tr> 
            <tr>
                <th>Type</th>
                <td>{{panel.type}} </td>
            </tr>                      
            <tr>
                <th class="title-section" colspan=2>Electrical</th>
            </tr>
            <tr>
                <th>Power P(W)</th>
                <td>{{panel.electrical?.power | number: '2.2-2' }} </td>
            </tr>
            <tr>
                <th>Efficiency</th>
                <td>{{panel.electrical?.efficency | number: '2.2-2' }} </td>
            </tr>
            <tr>
                <th>Voltage at maximum power Vmp(V)</th>
                <td>{{panel.electrical?.Vmp | number: '2.2-2' }} </td>
            </tr>
            <tr>
                <th>Open circuit oltage Voc(V)</th>
                <td>{{panel.electrical?.Voc?.gradient | number: '2.2-2' }} </td>
            </tr>
            <tr>
                <th>Current at maximum power Imp(A)</th>
                <td>{{panel.electrical?.Imp | number: '2.2-2' }} </td>
            </tr>
            <tr>
                <th>Short circuit current Isc(A)</th>
                <td>{{panel.electrical?.Isc | number: '2.2-2' }} </td>
            </tr> 
            <tr>
                <th class="title-section" colspan=2>Mechanical </th>
            </tr>
            <tr>
                <th>Dimensions (LxWxD)mm</th>
                <td>L:{{panel.mechanical?.H}}  W:{{panel.mechanical?.W}} D:{{panel.mechanical?.D}}</td>
            </tr>           
        </table>
    </div>
</div>
<div mat-dialog-actions style="width:100%;" class="justify-content-end mat-dialog-actions" *ngIf="!showflat">    
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>